import { render, staticRenderFns } from "./storehouseManageList.vue?vue&type=template&id=082e0084&scoped=true"
import script from "./storehouseManageList.vue?vue&type=script&lang=js"
export * from "./storehouseManageList.vue?vue&type=script&lang=js"
import style0 from "./storehouseManageList.vue?vue&type=style&index=0&id=082e0084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e0084",
  null
  
)

export default component.exports